import { render, staticRenderFns } from "./BlockingRulePage.vue?vue&type=template&id=4f0a40df&"
import script from "./BlockingRulePage.vue?vue&type=script&lang=js&"
export * from "./BlockingRulePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports